const STATUS_LABEL = {
  none: "No billing",
  current: "Current",
  past_due: "Past due",
  unpaid: "Unpaid",
  incomplete: "Incomplete",
  requires_action: "Action required",
};

const STATUS_TOOLTIP = {
  // Phase 7.5 — card auth pending OR bank-account verification in progress.
  incomplete: "Card authorization pending or bank-account verification in progress",
};

const STATUS_TINT = {
  none: "bg-slate-100 text-slate-600 border-slate-300",
  current: "bg-emerald-100 text-emerald-800 border-emerald-300",
  past_due: "bg-amber-100 text-amber-900 border-amber-300",
  unpaid: "bg-red-100 text-red-900 border-red-300",
  incomplete: "bg-slate-100 text-slate-700 border-slate-300",
  requires_action: "bg-amber-100 text-amber-900 border-amber-400",
};

export default function BillingStatusBadge({ status }) {
  const tint = STATUS_TINT[status] || STATUS_TINT.none;
  const tooltip = STATUS_TOOLTIP[status] || undefined;
  return (
    <span
      data-testid={`billing-status-${status || "none"}`}
      title={tooltip}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tint}`}
    >
      {STATUS_LABEL[status] || status || "—"}
    </span>
  );
}
